export const FETCH_PAGE_DATA = 'FETCH_PAGE_DATA';
export const FETCH_COMPONENT_DATA = 'FETCH_COMPONENT_DATA';
export const FETCH_EVENTS_DATA = 'FETCH_EVENTS_DATA';
export const FETCH_ARTICLES_DATA = 'FETCH_ARTICLES_DATA';
export const FETCH_AUTHORS_DATA = 'FETCH_AUTHORSS_DATA';
export const FETCH_NEWSLETTER_DATA = 'FETCH_NEWSLETTER_DATA';
export const FETCH_CONTENT_ERROR = 'FETCH_CONTENT_ERROR';



// WEBPACK FOOTER //
// ./src/services/contentEvents/types.js